import { ESCALA, PALETA_SERIES, escaparTexto, formatarValor } from "../tema";
import { opcoesBase } from "./base";

/**
 * Família 9 — rosca de participação.
 *
 * Fatias de um todo: destinos da exportação, market share, composição da
 * safra. Cada categoria vira uma fatia com o valor da primeira série; o
 * percentual é calculado pelo Highcharts, então a tabela pode vir tanto em
 * % quanto em toneladas.
 *
 * O texto do furo (ex.: "Total / 101,2 mi t") é desenho, em desenharCamadas.
 */
const modelo = {
  id: "rosca-participacao",
  label: "Rosca de participação",
  descricao: "Fatias de um todo com o percentual de cada uma. Ex.: destinos da exportação.",

  build(spec) {
    const base = opcoesBase(spec);
    const categorias = spec.dados?.categorias || [];
    const serie = spec.dados?.series?.[0] || {};
    const cores = spec.extras?.cores || [];
    const opcoesValor = spec.valores || {};
    const mostrarValor = spec.extras?.mostrarValor === true;
    const decimaisPct = spec.extras?.decimaisPercentual ?? 1;
    const legenda = Boolean(spec.legenda?.visivel);

    return {
      ...base,
      chart: {
        ...base.chart,
        type: "pie",
        marginBottom: (spec.extras?.rodape ? 16 : 8) * ESCALA,
      },
      xAxis: { ...base.xAxis, visible: false },
      yAxis: { ...base.yAxis, visible: false },
      legend: legenda
        ? { ...base.legend, align: "right", verticalAlign: "middle", layout: "vertical", y: 0 }
        : { ...base.legend, enabled: false },
      plotOptions: {
        ...base.plotOptions,
        pie: {
          innerSize: `${spec.extras?.furo ?? 62}%`,
          size: legenda ? "88%" : "82%",
          center: legenda ? ["36%", "50%"] : ["50%", "50%"],
          borderWidth: 2 * ESCALA,
          borderColor: spec.fundo || "#000000",
          startAngle: spec.extras?.anguloInicial ?? 0,
          showInLegend: legenda,
          dataLabels: {
            enabled: spec.valores?.exibirEm !== "nenhum",
            distance: 12 * ESCALA,
            connectorWidth: 1,
            connectorColor: "rgba(255,255,255,0.55)",
            crop: false,
            overflow: "allow",
            style: {
              color: "#FFFFFF",
              fontSize: `${Math.round(9 * ESCALA)}px`,
              fontWeight: "bold",
              textOutline: "none",
            },
            formatter() {
              const pct = formatarValor(this.percentage, { decimais: decimaisPct, sufixo: "%" });
              // Com legenda o nome já está ao lado; repetir só polui.
              const nome = legenda ? "" : `${escaparTexto(this.point.name)}<br>`;
              const valor = mostrarValor ? ` (${formatarValor(this.y, opcoesValor)})` : "";
              return `${nome}${pct}${valor}`;
            },
          },
        },
      },
      series: [
        {
          name: serie.nome || "Participação",
          data: categorias.map((nome, i) => ({
            name: nome,
            y: Number(serie.valores?.[i]) || 0,
            color: cores[i] || PALETA_SERIES[i % PALETA_SERIES.length].cor,
          })),
        },
      ],
    };
  },

  exemplo() {
    return {
      modelo: "rosca-participacao",
      titulo: [
        { texto: "Soja", cor: "#F0F000" },
        { texto: " - Destinos da Exportação ", cor: "#FFFFFF" },
        { texto: "(% do volume)", cor: "#FFFFFF", tamanho: 8 },
      ],
      subtitulo: [{ texto: "Jan a Ago/2026", cor: "#4EA6FF" }],
      fonte: "Fonte: RURAL BUSINESS/Comex Stat",
      fundo: "#000000",
      fundoPlot: "nenhum",
      dados: {
        categorias: ["China", "União Europeia", "Tailândia", "Espanha", "Outros"],
        series: [{ nome: "Participação", valores: [73.4, 5.1, 3.2, 2.9, 15.4] }],
      },
      legenda: { visivel: false },
      valores: { decimais: 1, prefixo: "", sufixo: "", exibirEm: "todos" },
      rotulo: { corTexto: "#FFFFFF", corFundo: "#1A1A1A", corBorda: "#FFFFFF" },
      extras: {
        furo: 62,
        decimaisPercentual: 1,
        centro: { titulo: "Total", valor: "101,2 mi t" },
        cores: ["#FF3B30", "#0070C0", "#3DAA73", "#FF8C00", "#8C8C8C"],
      },
    };
  },
};

export default modelo;
